
import { FBF_CloudCallable } from '@rabbit/firebase/adapter';
import { SendPasswordlessLoginEmailDto } from '@rabbit/nest/api';

export const nestApiSendPasswordlessLogin = FBF_CloudCallable<SendPasswordlessLoginEmailDto, any>(
  'api/auth/send-passwordless-login'
);

export const nestApiVerifyMagicToken = FBF_CloudCallable<any, any>(
  'api/auth/verify-magic-token'
);